export default __webpack_public_path__ + "static/media/edge-logo.a741b1df.svg";